import _ from 'lodash';
import Firebase from 'firebase';
import Moment from 'moment';

export class _AdminUtilities {

  constructor() {
  }

  init(database) {
    this.database = database;
  }

  resetAndArchiveLeaderboards() {

    // make a copy of current leaderboard state and reset scores
    let scoresRef = this.database.ref('scores');
    console.info('Loading leaderboard data...');
    scoresRef.once('value', snapshot => {
      if (!snapshot.exists()) return false;
      let scores_data = snapshot.val();

      // let currentDateTime = Firebase.database.ServerValue.TIMESTAMP;
      console.info('... Saving leaderboard data ...');
      // copy the current scores table to an archive node (no data lost permanently)
      // saved with an id that is the current timestamp, so can be analysed or restored (or even shown in app) after removal
      let scoreArchiveRef = Firebase.database().ref("scores_archive");
      scoreArchiveRef.child(Date.now()).update(scores_data).then(() => {
        // now safe to remove the original score/leaderboard data (this resets the leaderboards)
        scoresRef.update(
          {
            categories: null,
            quizzes: null,
            users: null
          }).then(() => {
          console.info('... Leaderboards reset ...');
        });

      }).catch(function (error) {
        console.error('Error archiving leaderboards', error);
      });
    });


    // delete the scores node


  }

  restoreLastLeaderboardState() {

    // make a copy of current leaderboard state and reset scores
    let scoreArchiveRef = this.database.ref('scores_archive');
    console.info('Loading archived leaderboard data...');
    scoreArchiveRef.limitToLast(1).on('child_added', snapshot => {

      // first item only
      let scores_data = snapshot.val();

      console.info('... Restoring leaderboard data ...' + snapshot.key);

      let scoreRef = Firebase.database().ref("scores");
      let scoresData = {
        categories: scores_data.categories,
        quizzes: scores_data.quizzes,
        users: scores_data.users
      }
      scoreRef.set(scores_data).then(() => {
        // scoresRef.remove();
        console.info('... Leaderboards reset ...');
      }).catch(function (error) {
        console.error('Error archiving leaderboards', error);
      });
    });


    // delete the scores node


  }

  clearOnline() {
    let onlineRef = this.database.ref('online');
    onlineRef.once('value', snapshot => {
      if (!snapshot.exists()) return false;
      let online_data = snapshot.val();
      _.mapKeys(online_data, (value, key) => {
        let u = value;
        u.id = key;

        let ref = this.database.ref('online/' + key);
        ref.update({active: null, connected: 1484743015405}).then(() => {
          console.log('Saved online for ' + key);
        })
          .catch(function (error) {
            console.error('Error', error);
          });
      });
    });
  }

  fixStatXP() {
    let c = 0;
    let quizRef = this.database.ref('quizzes');
    quizRef.on('child_added', quizS => {

      let quiz = quizS.val();
      let quizId = quizS.key;

      let scoresRef1 = this.database.ref('scores/quizzes/' + quizId);

      let count = 0;
      // filters out only active users
      scoresRef1.orderByChild("xp").startAt(1).once('value', snapshot => {
        if (!snapshot.exists()) return false;
        let scores_data = snapshot.val();
        _.mapKeys(scores_data, (value, key) => {
          let u = value;
          u.id = key;
          // if (!u.won && !u.lost) u.new = true;
          if (!u.won) u.won = 0;
          if (!u.lost) u.lost = 0;
          // scores.push(u);
          if (!u.correct) u.correct = 0;
          if (!u.incorrect) u.incorrect = 0;
          let played = parseInt((u.correct + u.incorrect) / 5, 10);
          let played2 = (u.won + u.lost);
          // console.log("Q1", u.id, u.xp, played, played2);

          let unknown = played - played2;
          let totalWins = u.won;

          // console.log(unknown, "games unaccounted for")

          if (played2 < played) totalWins = unknown + u.won;

          let stat = {
            Correct: u.correct,
            Incorrect: u.incorrect,
            XP: u.xp,
          }

          count++;
          c++;

          console.log(c, quizId, count, stat);

          // update stats
          let statRef = this.database.ref('stats/' + u.id + '/' + quizId);
          statRef.update(stat).then(() => {
            console.log('Saved XP stat for ' + u.id, stat);
          }).catch(function (error) {
            console.error('Error', error);
          });

          // update quiz total
          let scoreRef = this.database.ref('scores/quizzes/' + quizId + '/' + u.id);
          scoreRef.update({won: totalWins}).then(() => {
            console.log('Saved quiz score wins for ' + u.id, totalWins);
          }).catch(function (error) {
            console.error('Error', error);
          });
        });
      });

    });

    let scoresRef2 = this.database.ref('scores/users');

    let count = 0;
    // filters out only active users
    scoresRef2.orderByChild("xp").startAt(1).once('value', snapshot => {
      if (!snapshot.exists()) return false;
      let scores_data = snapshot.val();
      _.mapKeys(scores_data, (value, key) => {
        let u = value;
        u.id = key;
        // if (!u.won && !u.lost) u.new = true;
        if (!u.won) u.won = 0;
        if (!u.lost) u.lost = 0;
        // scores.push(u);
        if (!u.correct) u.correct = 0;
        if (!u.incorrect) u.incorrect = 0;
        let played = parseInt((u.correct + u.incorrect) / 5, 10);
        let played2 = (u.won + u.lost);
        // console.log("Q1", u.id, u.xp, played, played2);

        let unknown = played - played2;
        let totalWins = u.won;

        // console.log(unknown, "games unaccounted for")

        if (played2 < played) totalWins = unknown + u.won;

        let stat = {
          NumGames: played,
          NumWins: totalWins,
          NumLost: u.lost,
          Correct: u.correct,
          Incorrect: u.incorrect,
          XP: u.xp
        }

        count++;
        c++;

        console.log(c, u.id, count, stat);

        // update quiz total
        let scoreRef = this.database.ref('scores/users/' + u.id);
        scoreRef.update({won: totalWins}).then(() => {
          console.log('Saved user score wins for ' + u.id, totalWins);
        }).catch(function (error) {
          console.error('Error', error);
        });
      });
    });

  }

  fixStatWins() {
    let c = 0;
    let quizRef = this.database.ref('quizzes');
    quizRef.on('child_added', quizS => {

      let quiz = quizS.val();
      let quizId = quizS.key;

      let scoresRef1 = this.database.ref('scores/quizzes/' + quizId);

      let count = 0;
      // filters out only active users
      scoresRef1.orderByChild("xp").startAt(1).once('value', snapshot => {
        if (!snapshot.exists()) return false;
        let scores_data = snapshot.val();
        _.mapKeys(scores_data, (value, key) => {
          let u = value;
          u.id = key;
          // if (!u.won && !u.lost) u.new = true;
          if (!u.won) u.won = 0;
          if (!u.lost) u.lost = 0;
          // scores.push(u);
          if (!u.correct) u.correct = 0;
          if (!u.incorrect) u.incorrect = 0;
          let played = parseInt((u.correct + u.incorrect) / 5, 10);
          let played2 = (u.won + u.lost);
          // console.log("Q1", u.id, u.xp, played, played2);

          let unknown = played - played2;
          let totalWins = u.won;

          // console.log(unknown, "games unaccounted for")

          if (played2 < played) totalWins = unknown + u.won;

          let stat = {
            IsCertified: "No",
            LDAP: key,
            NumGames: played,
            NumWins: totalWins,
            NumLost: u.lost,
            Correct: u.correct,
            Incorrect: u.incorrect,
            XP: u.xp,
            QuizzID: quizId,
            QuizzTitle: quiz.title
          }

          count++;
          c++;

          console.log(c, quizId, count, stat);

          // update stats
          let statRef = this.database.ref('stats/' + u.id + '/' + quizId);
          statRef.set(stat).then(() => {
            console.log('Saved stat for ' + u.id, stat);
          }).catch(function (error) {
            console.error('Error', error);
          });

          // update quiz total
          let scoreRef = this.database.ref('scores/quizzes/' + quizId + '/' + u.id);
          scoreRef.update({won: totalWins}).then(() => {
            console.log('Saved quiz score wins for ' + u.id, totalWins);
          }).catch(function (error) {
            console.error('Error', error);
          });
        });
      });

    });

    let scoresRef2 = this.database.ref('scores/users');

    let count = 0;
    // filters out only active users
    scoresRef2.orderByChild("xp").startAt(1).once('value', snapshot => {
      if (!snapshot.exists()) return false;
      let scores_data = snapshot.val();
      _.mapKeys(scores_data, (value, key) => {
        let u = value;
        u.id = key;
        // if (!u.won && !u.lost) u.new = true;
        if (!u.won) u.won = 0;
        if (!u.lost) u.lost = 0;
        // scores.push(u);
        if (!u.correct) u.correct = 0;
        if (!u.incorrect) u.incorrect = 0;
        let played = parseInt((u.correct + u.incorrect) / 5, 10);
        let played2 = (u.won + u.lost);
        // console.log("Q1", u.id, u.xp, played, played2);

        let unknown = played - played2;
        let totalWins = u.won;

        // console.log(unknown, "games unaccounted for")

        if (played2 < played) totalWins = unknown + u.won;

        let stat = {
          NumGames: played,
          NumWins: totalWins,
          NumLost: u.lost,
          Correct: u.correct,
          Incorrect: u.incorrect,
          XP: u.xp
        }

        count++;
        c++;

        console.log(c, u.id, count, stat);

        // update quiz total
        let scoreRef = this.database.ref('scores/users/' + u.id);
        scoreRef.update({won: totalWins}).then(() => {
          console.log('Saved user score wins for ' + u.id, totalWins);
        }).catch(function (error) {
          console.error('Error', error);
        });
      });
    });
  }

  compileStats() {
    let scoresRef1 = this.database.ref('scores/quizzes/-KSSxSj0hGY3bFVo3lOZ');
    scoresRef1.orderByChild("xp").startAt(1).once('value', snapshot => {
      if (!snapshot.exists()) return false;
      let scores_data = snapshot.val();
      _.mapKeys(scores_data, (value, key) => {
        let u = value;
        u.id = key;
        // if (!u.won && !u.lost) u.new = true;
        if (!u.won) u.won = 0;
        if (!u.lost) u.lost = 0;
        // scores.push(u);
        if (!u.correct) u.correct = 0;
        if (!u.incorrect) u.incorrect = 0;
        let played = parseInt((u.correct + u.incorrect) / 5, 10);
        let played2 = (u.won + u.lost);
        console.log("Q1", u.id, u.xp, played, played2);

        let stat = {
          IsCertified: "No",
          LDAP: key,
          NumGames: played,
          NumWins: u.won,
          QuizzID: "-KSSxSj0hGY3bFVo3lOZ",
          QuizzTitle: "General Knowledge Quiz"
        }

        let statRef = this.database.ref('stats/' + u.id + '/-KSSxSj0hGY3bFVo3lOZ');
        statRef.set(stat).then(() => {
          console.log('Saved stat for ' + u.id, stat);
        })
          .catch(function (error) {
            console.error('Error', error);
          });
      });
    });

    let scoresRef2 = this.database.ref('scores/quizzes/-KYJt7XAGe3W5WNydqQz');
    scoresRef2.orderByChild("xp").startAt(1).once('value', snapshot => {
      if (!snapshot.exists()) return false;
      let scores_data = snapshot.val();
      _.mapKeys(scores_data, (value, key) => {
        let u = value;
        u.id = key;
        // if (!u.won && !u.lost) u.new = true;
        if (!u.won) u.won = 0;
        if (!u.lost) u.lost = 0;
        // scores.push(u);
        if (!u.correct) u.correct = 0;
        if (!u.incorrect) u.incorrect = 0;
        let played = parseInt((u.correct + u.incorrect) / 5, 10);
        let played2 = (u.won + u.lost);
        console.log("Q2", u.id, u.xp, played, played2);

        let stat = {
          IsCertified: "No",
          LDAP: key,
          NumGames: played,
          NumWins: u.won,
          QuizzID: "-KYJt7XAGe3W5WNydqQz",
          QuizzTitle: "Apps Black Belt Basic"
        }

        let statRef = this.database.ref('stats/' + u.id + '/-KYJt7XAGe3W5WNydqQz');
        statRef.set(stat).then(() => {
          console.log('Saved stat for ' + u.id, stat);
        })
          .catch(function (error) {
            console.error('Error', error);
          });
        ;
      });
    });
  }

}

export let AdminUtilities = new _AdminUtilities();
